export enum StatementModalModes {
  CREATE = "create",
  EDIT = "edit",
  VIEW = "view",
}
